import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, CheckCircle2, Star, ArrowRight } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { CountdownTimer } from '../components/CountdownTimer';
import { Footer } from '../components/Footer';
export function UpsellPage() {
  return <div className="min-h-screen flex flex-col bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-571">
      {/* Warning Banner */}
      <div className="bg-urgency text-white py-3 px-4 text-center font-bold text-sm md:text-base tracking-wide flex items-center justify-center gap-2" data-id="element-572">
        <AlertTriangle size={20} className="animate-pulse" data-id="element-573" />
        ¡ESPERA! TU PEDIDO AÚN NO ESTÁ COMPLETO
      </div>

      <main className="flex-grow py-12 md:py-16 px-4" data-id="element-574">
        <div className="max-w-4xl mx-auto" data-id="element-575">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-576">
            <h1 className="font-serif text-3xl md:text-5xl font-bold text-forest mb-6 leading-tight" data-id="element-577">
              Tenemos una <span className="text-urgency" data-id="element-578">oferta exclusiva</span>{' '}
              solo para ti antes de finalizar
            </h1>
            <p className="text-lg md:text-xl text-dark/80 font-medium max-w-2xl mx-auto" data-id="element-579">
              Como nuevo miembro, tienes la oportunidad única de añadir este
              complemento acelerador a tu pedido con un descuento irrepetible.
            </p>
          </div>

          {/* Video/Image Placeholder */}
          <div className="w-full aspect-video bg-dark/5 rounded-2xl border-2 border-dashed border-dark/20 flex items-center justify-center mb-12 relative overflow-hidden" data-id="element-580">
            <div className="text-center p-6" data-id="element-581">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm" data-id="element-582">
                <div className="w-0 h-0 border-t-8 border-t-transparent border-l-12 border-l-forest border-b-8 border-b-transparent ml-1" data-id="element-583"></div>
              </div>
              <p className="text-dark/50 font-medium" data-id="element-584">
                Video de Ventas Upsell (Opcional)
              </p>
            </div>
          </div>

          {/* Offer Card */}
          <div className="bg-white rounded-3xl p-1 shadow-2xl relative overflow-hidden mb-12" data-id="element-585">
            <div className="absolute inset-0 bg-gradient-to-r from-gold/40 via-white to-gold/40 opacity-50" data-id="element-586"></div>

            <div className="bg-white rounded-[22px] p-6 md:p-10 relative z-10 border border-gold/20" data-id="element-587">
              <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-588">
                {/* Product Image Placeholder */}
                <div className="w-full md:w-1/3 aspect-[3/4] bg-cream-dark rounded-xl flex items-center justify-center border border-forest/10 shrink-0" data-id="element-589">
                  <span className="text-dark/40 font-medium text-center px-4" data-id="element-590">
                    Imagen del Producto Upsell
                  </span>
                </div>

                {/* Product Details */}
                <div className="flex-1" data-id="element-591">
                  <div className="inline-block px-3 py-1 bg-gold/20 text-gold-dark font-bold text-xs rounded-full mb-4 uppercase tracking-wider" data-id="element-592">
                    Oferta Única
                  </div>

                  <h2 className="font-serif text-2xl md:text-3xl font-bold text-forest mb-4" data-id="element-593">
                    [Nombre del Producto Upsell Acelerador]
                  </h2>

                  <p className="text-dark/70 mb-6 leading-relaxed" data-id="element-594">
                    Descripción persuasiva de por qué necesitan este producto
                    para obtener resultados más rápidos, fáciles o garantizados.
                    Este es el complemento perfecto para lo que acaban de
                    comprar.
                  </p>

                  <ul className="space-y-3 mb-8" data-id="element-595">
                    <li className="flex items-start gap-3" data-id="element-596">
                      <CheckCircle2 size={20} className="text-success shrink-0 mt-0.5" data-id="element-597" />
                      <span className="text-dark/80" data-id="element-598">
                        Beneficio principal y específico número uno.
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-599">
                      <CheckCircle2 size={20} className="text-success shrink-0 mt-0.5" data-id="element-600" />
                      <span className="text-dark/80" data-id="element-601">
                        Beneficio secundario que elimina una objeción.
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-602">
                      <CheckCircle2 size={20} className="text-success shrink-0 mt-0.5" data-id="element-603" />
                      <span className="text-dark/80" data-id="element-604">
                        Ahorro de tiempo o esfuerzo masivo.
                      </span>
                    </li>
                  </ul>

                  {/* Pricing Box */}
                  <div className="bg-cream p-6 rounded-xl border border-forest/10 text-center" data-id="element-605">
                    <p className="text-dark/60 font-medium mb-2" data-id="element-606">
                      Precio regular:{' '}
                      <span className="line-through" data-id="element-607">$97.00 USD</span>
                    </p>
                    <div className="flex items-center justify-center gap-4 mb-6" data-id="element-608">
                      <span className="text-5xl md:text-6xl font-serif font-bold text-urgency drop-shadow-sm" data-id="element-609">
                        $27.00{' '}
                        <span className="text-xl text-urgency/70" data-id="element-610">USD</span>
                      </span>
                    </div>

                    <CountdownTimer theme="light" durationMs={15 * 60 * 1000} storageKey="upsell_timer" className="mb-6" data-id="element-611" />

                    <CTAButton text="SÍ, QUIERO AÑADIR ESTO A MI PEDIDO" variant="urgency" className="text-lg md:text-xl py-4 mb-4" data-id="element-612" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* No Thanks Link */}
          <div className="text-center" data-id="element-613">
            <Link to="/thankyou1" className="inline-flex items-center justify-center text-dark/50 hover:text-dark transition-colors font-medium underline underline-offset-4" data-id="element-614">
              No gracias, no quiero aprovechar esta oferta única y continuaré
              sin este acelerador.
            </Link>
          </div>
        </div>
      </main>

      <Footer data-id="element-615" />
    </div>;
}